export const setChannel = (channel)=>{
  return{
    type:'SET_CHANNEL',
    payload:channel
  }
}


export const play = () => {
  return {
    type:'PLAY'
  }
}


export const stop = () => {
  return {
    type:'STOP'
  }
}



// WEBPACK FOOTER //
// ./src/actions/video.js